export default __webpack_public_path__ + "static/Web3MQLogo-5a265014529dd2eae2421502f0e12b02.png";